import { AxiosResponse, AxiosError } from 'axios';
import { message } from 'antd';
import { getAllParams } from '@/utils/tools';
import { storage } from '@/utils/storage';
import { getDeviceId } from '@/utils/device';
import { CODE_PASSWORD_CHANGE_REQUIRED } from '@/utils/constant';
import type { AxiosInstance } from 'axios';
import type { ResponseData } from './index';

const { location } = window;

export function setupInterceptors(instance: AxiosInstance) {
  // 请求拦截器
  instance.interceptors.request.use((config) => {
    const { token, platform } = getAllParams();
    if (token && (platform !== 'promotion')) storage.set('token', token);

    config.headers.set('Content-Language', storage.get('language') || 'zh');
    config.headers.set('token', token || storage.get('token') || '');
    config.headers.set('device-id', getDeviceId());
    return config;
  });

  // 响应拦截器
  instance.interceptors.response.use(
    (response: AxiosResponse<ResponseData>) => {
      const { data: { code, msg } } = response;
      if (code === 105009) {
        storage.safeClear();
        const { pathname, search } = location;
        const cleanSearch = new URLSearchParams(search);
        cleanSearch.delete('redirect');
        const redirect = cleanSearch.toString();
        const path = (pathname === '/login' ? '/home' : pathname) + (redirect ? `?${redirect}` : '');
        if (!getAllParams().token) location.replace(`${location.origin}/login?redirect=${path}`);
      } else if (+code !== 0 && +code !== CODE_PASSWORD_CHANGE_REQUIRED && msg) {
        message.open({ content: msg, type: 'error' });
      }
      return response;
    },
    (error: AxiosError) => {
      const { url, method } = error.config as any;
      let errorMsg = '网络异常，请检查网络后重试';

      if (error.code === 'ERR_CANCELED') {
        return Promise.reject(error);
      } else if (error.code === 'ECONNABORTED') {
        errorMsg = '请求超时，请稍后重试';
      } else if (!error.response) {
        errorMsg = '网络连接失败，请检查网络';
      } else if (error.response.status === 400) {
        errorMsg = '请求参数错误';
      } else if (error.response.status === 401) {
        errorMsg = '登录已过期，请重新登录';
      } else if (error.response.status === 403) {
        errorMsg = '无权限访问';
      } else if (error.response.status === 404) {
        errorMsg = '请求地址不存在';
      } else if (error.response.status >= 500) {
        errorMsg = '服务器异常，请稍后重试';
      }

      console.error(`[请求失败] ${url} [${method?.toUpperCase()}]`, error.message);
      if (errorMsg) message.error(errorMsg);
      return Promise.reject(error);
    }
  );
}